import React, { useContext, useEffect, useState } from 'react';
import {
  SwipeableDrawer,
  makeStyles,
  createStyles,
  Card,
  Avatar,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Badge,
} from '@material-ui/core';
import { useHistory } from 'react-router';

import PersonIcon from '@material-ui/icons/Person';
import LogoutIcon from '@material-ui/icons/MeetingRoom';
import PassIcon from '@material-ui/icons/LockOutlined';
import MailIcon from '@material-ui/icons/MailOutline';
import HomeIcon from '@material-ui/icons/HomeRounded';
import BellIcon from '@material-ui/icons/Notifications';

import User from '../../auth/User';
import { delayPush } from '../../helper/Util';
import { BadgeContext } from '../../containers/App';
import ConfirmDialog from './ConfirmDialog';

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    menuWidth: {
      width: 280,
    },
    menuHeader: {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
      height: theme.spacing(18),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    avatar: {
      width: theme.spacing(7),
      height: theme.spacing(7),
      marginBottom: theme.spacing(1),
      color: theme.palette.getContrastText(theme.palette.primary.light),
      backgroundColor: theme.palette.primary.light,
    },
  }),
);

export default function Menu(props) {
  const { onClose } = props;
  const classes = useStyles();
  const history = useHistory();
  const currentPage = history.location.pathname;

  const [userData, setUserData] = useState(null);
  const [isEmailLogin, setIsEmailLogin] = useState(false);
  const { isShowBadge, setIsShowBadge } = useContext(BadgeContext);
  const [isOpenConfirmLogout, setIsOpenConfirmLogout] = useState(false);

  useEffect(() => {
    let alive = true;

    (async () => {
      const data = await User.fetchUserData();
      if (!alive) return;
      setUserData(data);
      setIsEmailLogin(User.isEmailLoginFromUserData(data));
    })();

    return () => {
      alive = false;
    };
  }, []);

  const handleOkLogout = () => {
    delayPush(history, '/logout');
  };

  const mainItems = [
    {
      Icon: HomeIcon,
      label: 'ホーム',
      hasBadge: false,
      path: '/calendar',
      isShow: true,
    },
    {
      Icon: BellIcon,
      label: 'お知らせ',
      hasBadge: true,
      path: '/notification',
      isShow: true,
    },
    {
      Icon: MailIcon,
      label: '登録メール変更',
      hasBadge: false,
      path: '/mailchange',
      isShow: isEmailLogin,
    },
    {
      Icon: PassIcon,
      label: 'パスワード変更',
      hasBadge: false,
      path: '/passchange',
      isShow: isEmailLogin,
    },
  ];

  const handleClickMainItem = ({ path, hasBadge = false }) => {
    if (currentPage === path) {
      onClose();
    } else {
      if (hasBadge) setIsShowBadge(false);
      delayPush(history, path);
    }
  };

  return (
    <>
      <SwipeableDrawer {...props} disableDiscovery disableSwipeToOpen>
        <div className={classes.menuWidth}>
          {/* メニューヘッダー */}
          <Card className={classes.menuHeader} square>
            <Avatar className={classes.avatar}>
              <PersonIcon />
            </Avatar>
            <Typography variant="subtitle2">{userData ? userData.name : ''}様</Typography>
          </Card>

          {/* メニューリスト */}
          <List>
            {mainItems.map(
              (item, idx) =>
                item.isShow && (
                  <ListItem button onClick={() => handleClickMainItem(item)} key={idx}>
                    <ListItemIcon>
                      <Badge
                        variant="dot"
                        color="secondary"
                        overlap="circular"
                        invisible={!(item.hasBadge && isShowBadge)}
                      >
                        <item.Icon />
                      </Badge>
                    </ListItemIcon>
                    <ListItemText primary={item.label} />
                  </ListItem>
                ),
            )}
          </List>

          <Divider />

          <List>
            <ListItem button onClick={() => setIsOpenConfirmLogout(true)}>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary="ログアウト" />
            </ListItem>
          </List>
        </div>
      </SwipeableDrawer>

      <ConfirmDialog
        open={isOpenConfirmLogout}
        onClose={() => setIsOpenConfirmLogout(false)}
        onOk={handleOkLogout}
        okLabel="ログアウト"
        isDestructive
      >
        ログアウトしますか？
      </ConfirmDialog>
    </>
  );
}
